import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'
import { Button, TableColumnType } from 'antd'
import moment from 'moment'
import React, { ReactElement } from 'react'
import { DateTimeFormatSimple } from '../../../models/datetime'
import { Dimen } from '../../../models/dimen'

export const Columns = (
  onClick: (text: string, t: any) => void,
  startIndex: number
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      dataIndex: 'order',
      align: 'center',
      width: Dimen.Num,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '门店名称',
      dataIndex: 'tenantName',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantName ? t.tenantName : '-'
      },
    },
    // {
    //   title: '自编码',
    //   dataIndex: 'createTime',
    //   align: 'center',
    //   width: '8rem',
    //   ellipsis: true,
    // },
    {
      title: '商品名',
      dataIndex: 'tenantMaterialsName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.tenantMaterialsName ? t.tenantMaterialsName : '-'
      },
    },
    {
      title: '规格',
      dataIndex: 'packSpec',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.packSpec ? t.packSpec : '-'
      },
    },
    {
      title: '厂家',
      dataIndex: 'originName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.originName ? t.originName : '-'
      },
    },
    {
      title: '剂型',
      dataIndex: 'doseCategory	',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.doseCategory ? t.doseCategory : '-'
      },
    },
    {
      title: '批号',
      dataIndex: 'batchNo',
      align: 'center',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.batchNo ? t.batchNo : '-'
      },
    },
    {
      title: '单位',
      dataIndex: 'unit',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.unit ? t.unit : '-'
      },
    },
    {
      title: '供应商',
      dataIndex: 'supplierName',
      align: 'center',
      width: '12rem',
      ellipsis: true,
      render: (_, t) => {
        return t.supplierName ? t.supplierName : '-'
      },
    },
    {
      title: '有效期',
      dataIndex: 'periodValidity',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.periodValidity
          ? moment(t.periodValidity).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '报损数量',
      dataIndex: 'reportLossNumber',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossNumber ? t.reportLossNumber : '-'
      },
    },
    {
      title: '报损金额',
      dataIndex: 'reportLossPrice',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossPrice > 0 ? t.reportLossPrice?.toFixed(2) : '-'
      },
    },
    {
      title: '报损原因',
      dataIndex: 'reportLossReason',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossReason ? t.reportLossReason : '-'
      },
    },
    {
      title: '报损日期',
      dataIndex: 'reportLossDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossDate
          ? moment(t.reportLossDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '报损人',
      dataIndex: 'reportLossUserName',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.reportLossUserName ? t.reportLossUserName : '-'
      },
    },
    {
      title: '审核人',
      dataIndex: 'examineUserName',
      align: 'center',
      width: '7rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examineUserName ? t.examineUserName : '-'
      },
    },
    {
      title: '审核日期',
      dataIndex: 'examineDate',
      align: 'center',
      width: '8rem',
      ellipsis: true,
      render: (_, t) => {
        return t.examineDate
          ? moment(t.examineDate).format(DateTimeFormatSimple)
          : '-'
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '13rem',
      render: function Element(_, t) {
        return (
          <>
            {t?.examineStatus == 1 ? (
              <>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('lookDetail', t)
                  }}
                >
                  查看
                </Button>
              </>
            ) : (
              <>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  onClick={() => {
                    onClick('edit', t)
                  }}
                >
                  编辑
                </Button>
                <Button
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  disabled={t?.isEdit == 1 ? false : true}
                  onClick={() => {
                    onClick('audit', t)
                  }}
                >
                  审核
                </Button>
                <Button
                  danger
                  ghost
                  style={{ marginRight: '6px' }}
                  type='primary'
                  size='small'
                  disabled={t?.isEdit == 1 ? false : true}
                  onClick={() => {
                    onClick('delete', t)
                  }}
                >
                  删除
                </Button>
              </>
            )}
          </>
        )
      },
    },
  ]
}
